import { render, staticRenderFns } from "./ProfileOwner.vue?vue&type=template&id=2587bf86"
import script from "./ProfileOwner.vue?vue&type=script&lang=js"
export * from "./ProfileOwner.vue?vue&type=script&lang=js"
import style0 from "./ProfileOwner.vue?vue&type=style&index=0&id=2587bf86&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports